<script>
/**
 * Advanced table component
 */
export default {
  name: 'PlayersChart',
  props: {
    application_id: [Number, String],
    default: null,
  },
  data() {
    return {
      user: null,
      filterDays: 1,
      filterPeriod: 'روزانه',
      date: 'week',
      incomeData: '',
      spentData: '',
      series: [
        {
          name: 'تعداد کاربر جدید',
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'area',
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 1000,
            },
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        colors: ['#7deea3', '#ee7d7d'],
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: {
            formatter: function(value) {
              return value + 'نفر'
            },
          },
        },
      },
    }
  },
  mounted() {
    this.fetchChartData()
  },
  methods: {
    fetchChartData() {
      let route = `applications/players/chart/group-by-date?period=${this.date}`
      if (this.application_id) {
        route = `applications/${this.application_id}/players/chart/group-by-date?period=${this.date}`
      }
      this.$axios.get(route).then((res) => {
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            xaxis: {
              categories: res.data.labels,
            },
          },
        }
        this.series[0].data = res.data.data
        if (res.data.data.length > 0)
          this.$refs.realtimeChart.updateSeries(this.series, false, true)
      })
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mx-auto justify-content-between align-items-center">
            <h4 class="card-title mb-12">
              نمودار کاربران اپلیکیشن ها
            </h4>
            <div class="d-flex">
              <div class="mr-4">
                <label>دوره زمانی</label>
                <select
                  @change="fetchChartData"
                  v-model="date"
                  class="form-control"
                >
                  <option value="week">هفته جاری</option>
                  <option value="month">ماه جاری</option>
                  <option value="three_month">سه ماه گذشته</option>
                  <option value="six_month">6 ماه گذشته</option>
                  <option value="year">سال گذشته</option>
                </select>
              </div>
            </div>
          </div>
          <div>
            <div class="apex-charts" dir="rtl"></div>
            <apexchart
              class="apex-charts"
              dir="rtl"
              ref="realtimeChart"
              :series="series"
              :options="chartOptions"
              type="area"
              height="350"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
